import { render } from "./wContentCarousel.vue?vue&type=template&id=3b11b84c&scoped=true"
import script from "./wContentCarousel.vue?vue&type=script&lang=js"
export * from "./wContentCarousel.vue?vue&type=script&lang=js"

import "./wContentCarousel.vue?vue&type=style&index=0&id=3b11b84c&scoped=true&lang=scss"

import exportComponent from "/Users/jade/Documents/D1m/website-urlscheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b11b84c"]])

export default __exports__